import './App.css';
import {Box, Flex, Heading, HStack, Link, Text, VStack} from "@chakra-ui/react";
import {ChatIcon, EmailIcon, ExternalLinkIcon} from "@chakra-ui/icons";

function App() {
  return (
      <Flex w='100vw' h='100vh' alignItems={'center'} justifyContent={'center'} className={'bg'}>
          <Box flexDir={'column'} w={'70%'} minH={'30%'}>
              <VStack alignItems={'left'}>
                  <Heading as={'h1'}>Max Paniukov</Heading>
                  <Text>Front-end software developer.</Text>
                  <Text>Some of the projects I'm working on:</Text>
                  <VStack alignItems={'left'}>
                      <Link href={"https://state.twiforce.com"} target={"_blank"}><ExternalLinkIcon />Browser-based exploration incremental idle game</Link>
                      <Link href={"https://cgng01.web.app/"} target={"_blank"}><ExternalLinkIcon />Browser-based idle card game</Link>
                  </VStack>
                  <Text>Find more & Contact:</Text>
                  <HStack>
                      <Link href="https://github.com/twiforce" target="_blank" rel="noreferrer"><ExternalLinkIcon />Github</Link>
                      <Text>/</Text>
                      <Link href="https://t.me/twiforce" target={"_blank"}><ChatIcon />Telegram</Link>
                      <Text>/</Text>
                      <Link href="mailto:twiforce@ya.ru"><EmailIcon />Email</Link>
                  </HStack>
              </VStack>
          </Box>

      </Flex>
  );
}

export default App;
